exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.nil-sa-elements-link-style__noStyle,a.nil-sa-elements-link-style__noStyle:hover{color:#000}", ""]);

// exports
exports.locals = {
	"noStyle": "nil-sa-elements-link-style__noStyle"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/elements/Link/style.less
// module id = 235
// module chunks = 0